export interface PlanLimit {
  consultas: number;
  investigaciones: number;
  documentos: number;
  casos?: number;
  label: string;
}

export const PLAN_LIMITS: Record<string, PlanLimit> = {
  basico: {
    consultas: 150,
    investigaciones: 20,
    documentos: 10,
    casos: 45,
    label: "Plan Básico",
  },
  profesional: {
    consultas: 400,
    investigaciones: 50,
    documentos: 30,
    casos: 150,
    label: "Plan Profesional",
  },
  empresarial: {
    consultas: 2000,
    investigaciones: 200,
    documentos: 100,
    casos: 500,
    label: "Plan Empresarial",
  },
  free: {
    consultas: 8,
    investigaciones: 3,
    documentos: 5,
    casos: 10,
    label: "Plan Free",
  },
};
